<template>

    <v-page-body>

        <transition name="modal">
            <v-modal-block-delete v-if="showModal === 'delete'" :block="selectedBlock" @deleted="getBlocks" />
            <v-modal-block-edit v-if="showModal === selectedBlock.id" :block="selectedBlock" @saved="getBlocks" />
        </transition>

        <v-page-filters floating>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getBlocks" />
            <div></div>
        </v-page-filters>

        <v-notice v-if="!blocks.length"
            title="Add a Block"
            message="You can create reusable custom blocks to add to your emails and templates by pressing the save button in the actions bar of a block in the email builder.">
        </v-notice>

        <v-list v-else>
            <v-list-item v-for="block in blocks" :key="block.id">
                <div>
                    <span>{{ block.name }}</span><br>
                    <span class="small text-muted">{{ block.block.type }}</span>
                </div>
                <div>
                    <v-button class="float-right" size="sm" btn-style="secondary" @click.native="editBlock(block)">Edit</v-button>
                </div>
            </v-list-item>
        </v-list>

    </v-page-body>

</template>

<script>

import ProjectApi from '@api/ProjectApi';
import ModalBlockDelete from '@modals/block/ModalBlockDelete';
import ModalBlockEdit from '@modals/block/ModalBlockEdit';

export default {

    components: {
        'v-modal-block-delete': ModalBlockDelete,
        'v-modal-block-edit': ModalBlockEdit,
    },

    data() {
        return {
            blocks: [],
            selectedBlock: {},
            params: {},
        }
    },

    mounted() {
        this.getBlocks();
    },

    methods: {

        getBlocks() {
            this.$store.commit('loading', true);
            ProjectApi.getBlocks(this.project.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.blocks = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        editBlock(block) {
            this.selectedBlock = block;
            this.$store.commit('showModal', block.id);
        },

    },

}

</script>